<template>
  <section-container>
    <div class="w-full flex justify-center items-center flex-wrap p-2">
      <div class="w-full lg:w-1/3 flex flex-wrap flex-col">
        <h3 class="text-3xl font-bold mb-2">Configurações</h3>
        <h4 class="text-xl mb-5">Melhore ainda mais sua loja</h4>
      </div>
      <div class="w-full lg:w-2/3 flex justify-center items-center px-4 my-2">
        <img
          src="@/assets/img/categories.png"
          alt=""
          width="650px"
          class="h-auto overflow-hidden"
        />
      </div>
    </div>
    <content-e>
      <div
        class="w-full md:w-1/3 p-2"
        v-for="setting in settings"
        :key="setting.title"
      >
        <setting-card
          :title="setting.title"
          :description="setting.description"
          :to="setting.to"
        >
        </setting-card>
      </div>
    </content-e>
  </section-container>
</template>

<script>
import SettingCard from '@/components/Settings/SettingCard'
export default {
  name: '',
  components: {
    SettingCard
  },
  data() {
    return {
      settings: [
        {
          title: 'Sua Loja',
          description: 'Altere as informações basicas da sua Loja',
          to: 'settings.store'
        },
        {
          title: 'Contatos',
          description: 'Configure os contatos',
          to: 'settings.social'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  methods: {
    redirectToPage(name) {
      return this.$router.push({
        name: 'settings.' + name
      })
    }
  }
}
</script>
